import { extendTheme } from '@chakra-ui/react';
import { buttonTheme } from 'components/Button/buttonTheme';

export const iconButtonTheme = extendTheme({
  components: { Button: buttonTheme },
});
